import api from './api';

const baselineService = {
  // Get all baselines with filtering and pagination
  getAllBaselines: async (params = {}) => {
    const response = await api.get('/baselines', { params });
    return response.data;
  },

  // Get baseline by ID
  getBaselineById: async (id) => {
    const response = await api.get(`/baselines/${id}`);
    return response.data;
  },

  // Create new baseline
  createBaseline: async (baselineData) => {
    const response = await api.post('/baselines', baselineData);
    return response.data;
  },

  // Update baseline
  updateBaseline: async (id, baselineData) => {
    const response = await api.put(`/baselines/${id}`, baselineData);
    return response.data;
  },

  // Delete baseline
  deleteBaseline: async (id) => {
    const response = await api.delete(`/baselines/${id}`);
    return response.data;
  },

  // Approve baseline
  approveBaseline: async (id) => {
    const response = await api.post(`/baselines/${id}/approve`);
    return response.data;
  },

  // Archive baseline
  archiveBaseline: async (id) => {
    const response = await api.post(`/baselines/${id}/archive`);
    return response.data;
  },

  // Get baselines by project
  getBaselinesByProject: async (projectId) => {
    const response = await api.get(`/baselines/project/${projectId}`);
    return response.data;
  },

  // Compare two baselines
  compareBaselines: async (baseline1Id, baseline2Id) => {
    const response = await api.get('/baselines/compare', {
      params: {
        baseline1_id: baseline1Id,
        baseline2_id: baseline2Id
      }
    });
    return response.data;
  },

  // Get baseline statistics
  getBaselineStatistics: async () => {
    const response = await api.get('/baselines/statistics');
    return response.data;
  }
};

export default baselineService;


